import React from "react";
import SimpleMenuNoLanguage from "./stories/components/SimpleMenuNoLanguage";
import { useLocation } from "react-router-dom";

export default function Navigation() {
  const location = useLocation();
  var navigation;
  if (location.pathname === "/") {
    // Frontpage //
    navigation = <SimpleMenuNoLanguage title="Profilhåndbok" homeUrl="/" />;
  } else {
    // Subpages //
    navigation = (
      <>
        <a
          aria-label="Hopp til innhold"
          className="sr-only"
          href="#hovedinnhold"
        >
          Hovedinnhold
        </a>
        <SimpleMenuNoLanguage
          title="Profilhåndbok"
          homeUrl="/"
          items={[
            {
              url: "/om-statsforvalteren",
              linkText: "Statsforvalteren",
            },
            {
              url: "/om-profilen",
              linkText: "Profilen",
            },
            {
              url: "/logo",
              linkText: "Logo",
            },
            {
              url: "/farger",
              linkText: "Farger",
            },
            {
              url: "/typografi",
              linkText: "Typografi",
            },
            {
              url: "/språk",
              linkText: "Språk",
            },
            {
              url: "/mønster",
              linkText: "Mønster",
            },
            {
              url: "/maler",
              linkText: "Maler",
            },
            {
              url: "/fotoarkiv",
              linkText: "Fotoarkiv",
            },
            {
              url: "/storybook",
              linkText: "Komponentbibliotek",
            },
          ]}
        />
      </>
    );
  }

  return <>{navigation}</>;
}
